import React from 'react';
import { pridi } from '../fonts';

interface GameTitleProps {
  logoSrc: string;
}

const GameTitle: React.FC<GameTitleProps> = ({ logoSrc }) => {
  return (
    <div className='m-0'>
      <div className="flex items-center gap-2 px-0">
        <img src={logoSrc} alt="StickerChain logo" className="w-10 h-10 rounded-md" />
        <div>
          <h1 className={`text-2xl tracking-wide ${pridi.className}`}>StickerChain</h1>
          <p className='text-sm text-gray-400 font-medium tracking-tight mt-0 leading-tight'>
            Slap the Planet!
          </p>
        </div>
      </div>
    </div>
  );
};

export default GameTitle;
